import React, { Component } from 'react';
import {
  Grid, Col, Row, Image
} from 'react-bootstrap';
import { Link } from 'react-router';
import { styles } from './Footer.style';
import { APP_CONFIG } from './../../../boot.config';

/** CUSTOM COMPONENTS **/
import { Logo } from './../../Global/Logo/Logo';
export class Footer extends Component{
  render(){
    let year = new Date();
    year = year.getFullYear();
    return (
      <Col xs={12} md={12} className={'footerContainer'}>
        <Grid className={'no-padding'}>
          <Col xs={12} md={12}>
            <Col xs={12} md={3} className={'no-padding'}>
              <h3>Conheça mais</h3>
              <ul>
                <h4>Tchau Varal</h4>
                <li>Endereço 222</li>
                <li>Franca SP</li>
                <br/>
                <li>(12) 4567-8900 / (12) 5555-7891</li>
                <li>email@{APP_CONFIG.PROJECT_DOMAIN}</li>
              </ul>
            </Col>
            <Col xs={12} md={3}>
              <h3>Informações</h3>
              <ul>
                <li>Press release</li>
                <li>Terms and conditions</li>
                <li>Privacy policy</li>
                <li>Carrer center</li>
                <li>Contact us</li>
              </ul>
            </Col>
            <Col xs={12} md={3}>
              <h3>Páginas</h3>
              <ul>
                <li>Press release</li>
                <li>Terms and conditions</li>
                <li>Privacy policy</li>
                <li>Carrer center</li>
                <li>Contact us</li>
              </ul>
            </Col>
            <Col xs={12} md={3}>
              <h3>Contato</h3>
              <ul>
                <li>Fill your email and sign up for monthly newsletter to keep updated</li>
                <li>
                  <Col xs={12} md={10} className={'no-padding'}>
                    <input
                      type={'text'}
                      ref={'emailNewsletter'}
                      className={'input-control no-margin radiusLeft-only'}
                    />
                  </Col>
                  <Col xs={12} md={2} className={'no-padding'}>
                    <Link
                      to={'#newsletter'}
                      className={'btn btn-primary no-margin no-radiusLeft'}>
                      Enviar
                    </Link>
                  </Col>
                </li>
              </ul>
            </Col>
          </Col>
        </Grid>
        <Col xs={12} md={12} className={'copyright'}>
          <span> {APP_CONFIG.PROJECT_NAME} &copy; {year} - Todos os direitos reservados.</span>
        </Col>
        {/*
        <Col xs={12} md={2}>
          <a className={'assinatura'} title={'Desenvolvido por iDrops'} href={'http://www.dropspublicidade.com.br'} target={'_blank'} />
        </Col> */}
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Site/Footer/Footer.js